<template>
  <div class="all">
    <my-title :msg="title"></my-title>
    <div class="personalinformation_bot">
      <button style="background: #50bdde;" :class="ommodities == 0?'button_ca':''" @click="ommodities = 0">个人信息</button>
      <button style="background: #5cd796;" :class="ommodities !== 0?'button_ca':''" @click="ommodities = 1">密码修改</button>
    </div>
    <div class="personalinformation_text" v-if="ommodities == 0">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="上传头像">
          <el-upload
            class="avatar-uploader"
            action="/"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="image" :src="image" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model="form.name" style="width: 80%" disabled></el-input>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="form.real_name" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="form.phone" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱">
          <el-input v-model="form.email" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="所在区域">
          <el-select v-model="form.pro_id" placeholder="省" style="width: 30%" @change="getAdd(form.pro_id)">
            <el-option :label="item.name" :value="item.id" v-for="(item,key) in prodata" :key="item.id"></el-option>
          </el-select>
          <el-select v-model="form.city_id" placeholder="市" style="width: 30%" @change="getAdd1(form.city_id)">
            <el-option :label="item.name" :value="item.id" v-for="(item,key) in citydata" :key="item.id"></el-option>
          </el-select>
          <el-select v-model="form.area_id" placeholder="区/县" style="width: 30%">
            <el-option :label="item.name" :value="item.id" v-for="(item,key) in areadata" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入详细地址"
            v-model="form.add_ress"
            style="width: 80%"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getFin">保存修改</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="personalinformation_text" style="margin-top: 150px" v-if="ommodities == 1">
      <el-form ref="form" :model="form1" label-width="100px">
        <el-form-item label="输入旧密码">
          <el-input v-model="form1.y_pass" show-password style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="输入新密码">
          <el-input v-model="form1.x_pass" show-password style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input v-model="form1.q_pass" show-password style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getFinpass">确认修改</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {getCity,getsave,getimg,getsavePass } from '../api/Mycen'
    export default {
        name: "personalinformation",
        data(){
          return{
            dialogVisible:false,
            title:'个人信息',
            ommodities:0,
            //  默认地址修改  参数
            image:'',
            form: {
              img:this.$store.state.user.uesr.image,
              name: this.$store.state.user.uesr.user_name,
              real_name: this.$store.state.user.uesr.real_name,
              phone:this.$store.state.user.uesr.phone,
              email: this.$store.state.user.uesr.email,
              delivery: false,
              pro_id:String(this.$store.state.user.uesr.pro_id),
              city_id:String(this.$store.state.user.uesr.city_id),
              area_id:String(this.$store.state.user.uesr.area_id),
              add_ress:this.$store.state.user.uesr.add_ress,
            },
            form1:{
              y_pass:'',
              x_pass:'',
              q_pass:'',
            },
            // 发票参数
            radio:1,
            Options:"1",  //备选项
            textarea:"",  //备注
            prodata:[],  //省
            citydata:[],  //市
            areadata:[],  //区
          }
        },
      mounted() {
        this.init()
        // console.log(this.$store.state.user.uesr)
      },
      methods:{
        getFin(){
          getsave(this.form).then(res=>{
            this.$store.dispatch('GetInfo').then(res=>{
              window.location.reload()
            })
          })
        },
        getFinpass(){
          getsavePass(this.form1).then(res=>{
            // res.msg
            this.$store.dispatch('GetInfo').then(res=>{

            })
          })
        },
        init(){
          getCity({}).then(res=>{
            this.prodata = res.result
            getCity({parentid:this.$store.state.user.uesr.pro_id}).then(res=>{
              this.citydata = res.result
              getCity({parentid:this.$store.state.user.uesr.city_id}).then(res=>{
                this.areadata = res.result
              })
            })
          })
        },
        getAdd(e){
          getCity({parentid:e}).then(res=>{
            this.citydata = res.result
            this.form.city_id = ''
            this.form.area_id = ''
          })
        },
        getAdd1(e){
          getCity({parentid:e}).then(res=>{
            this.areadata = res.result
          })
        },
        handleAvatarSuccess(res, file) {
          this.form.img = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
          const isJPG = file.type === 'image/jpeg';
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isJPG) {
            this.$message.error('上传头像图片只能是 JPG 格式!');
          }
          if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
          }
          let reader = new FileReader();
          reader.readAsDataURL(file);
          let that=this;
          reader.onload=function (e) {
            that.image = e.target.result
            getimg({img:e.target.result}).then(res=>{
              that.form.img = res.result
            })
          };
          return isJPG && isLt2M;
        }
      }
    }
</script>

<style scoped lang="less">
  @import "css/personalinformation";
</style>



// WEBPACK FOOTER //
// src/components/personalinformation.vue